import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import { cities } from '@/data/cities';

export const CitiesSection = () => {
  const cityList = Object.values(cities);

  return (
    <section className="py-24 px-6 bg-muted" data-testid="cities-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm uppercase tracking-[0.2em] mb-3 font-mono text-accent">Locations</p>
          <h2 className="text-4xl sm:text-5xl font-bold mb-4" style={{ fontFamily: 'Cabinet Grotesk' }}>
            Serving Major Cities Across Pakistan
          </h2>
          <p className="text-lg text-muted-foreground">Rent a car anywhere from Karachi to the Karakoram</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {cityList.map((city, index) => (
            <Link
              key={city.slug}
              to={`/rent-a-car/${city.slug}`}
              className="bg-white rounded-lg p-6 hover:shadow-lg transition-all group border border-border hover:border-accent"
              data-testid={`city-card-${city.slug}`}
            >
              <div className="flex items-center justify-between mb-3">
                <MapPin className="w-8 h-8 text-accent" />
                <ArrowRight className="w-5 h-5 text-muted-foreground group-hover:text-accent group-hover:translate-x-1 transition-all" />
              </div>
              <h3 className="text-xl font-bold mb-2">{city.name}</h3>
              <p className="text-xs text-muted-foreground line-clamp-2">{city.heroSubtitle}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
